<template>
    <div v-if="!noResults" class="hero category-section is-white">
        <div class="hero-body">
            <template v-if="category">
                <div class="block">
                    <router-link class="tag is-primary is-large is-radiusless has-text-weight-normal"
                                 :to="{ name: 'blog.category', params: { slug: category.slug } }">
                        {{ category.name }}
                    </router-link>

                    <router-link class="is-pulled-right has-text-weight-light is-size-5"
                                 :to="{ name: 'blog.category', params: { slug: category.slug } }">
                        <span>Se flere {{category.name}}</span>
                        <b-icon icon="arrow-right"></b-icon>
                    </router-link>
                </div>

                <div class="columns" v-if="posts.length">
                    <div v-for="post in posts" :key="post.id" class="column is-4">
                        <category-section-item :post="post" />
                    </div>
                </div>

                <div v-else class="has-text-centered">
                    <span>Indlæser..</span> <br>
                    <b-icon icon="loading" custom-class="mdi-spin" />
                </div>
            </template>

            <div v-else class="has-text-centered">
                <span>Indlæser kategori..</span> <br>
                <b-icon icon="loading" custom-class="mdi-spin" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .category-section {
        margin-bottom: 1rem;

        .hero-body {
            padding: 1.5rem;

            .block {
                font-family: "Oswald", sans-serif;
            }
        }
    }
</style>

<script>
    import CategorySectionItem from '@/taskflex/blog/components/CategorySectionItem';

    export default {
        data() {
            return {
                noResults: false,
                posts: [],

                category: null,
            };
        },

        props: {
            categoryId: {
                type: Number,
                required: true,
            },
        },

        mounted() {
            this.$store.dispatch('blog/loadCategory', {
                id: this.categoryId,
            }).then((category) => {
                this.category = category;

                this.$store.dispatch('blog/fetchPostsForCategory', {
                    id: this.categoryId,
                }).then((posts) => {
                    this.posts = posts.slice(0, 3);

                    if (!this.posts.length) {
                        this.noResults = true;
                    }
                });
            });
        },

        components: {
            CategorySectionItem,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/components/CategorySection.vue